<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
      <v-card flat>
        <v-card-text>
          <h3>INTERBANK / Gestiones pendientes</h3>
        </v-card-text>
        <v-layout row wrap>
          <v-flex xs12 md12 lg12>
            <v-text-field label="Buscar por Agente..." v-model="agents"></v-text-field>
          </v-flex>
          <v-flex xs12 md4 lg4>
            <v-select
              :items="bloques"
              label="Filtrar Bloque"
              item-text="bloque"
              item-value="bloque"
              v-model="bloque"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4 lg4>
            <v-select
              :items="types"
              label="Filtrar Tipo"
              item-text="text"
              item-value="value"
              v-model="type"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4 lg4>
            <v-select
              :items="statusfilter"
              label="Filtrar Estado"
              item-text="text"
              item-value="value"
              v-model="statusfilterSelect"
            ></v-select>
          </v-flex>
          <v-btn color="success" @click="getList1()">Buscar</v-btn>
          <download-excel :data="json_data" :fields="json_fields">
            <v-btn color="blue-grey" class="white--text">
              <v-icon right dark>assignment_returned</v-icon>Descargar Excel
            </v-btn>
          </download-excel>
        </v-layout>
        <v-divider></v-divider>
        <v-data-table
          :headers="data_pendings.headers"
          :items="data_pendings.items"
          :loading="listLoading1"
          :search="search1"
          :rows-per-page-items="[10, 100, 200, 500]"
          :expand="expand"
        >
          <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
            <td>{{ props.item.bloque }}</td>
            <td>{{ props.item.agent_id }}</td>
            <td>{{ props.item.agents.name }}</td>
            <td>{{ props.item.num }}</td>
            <td>{{ props.item.serie }}</td>
            <td style="display: inline-flex;">{{ props.item.type }} 
              <a :href="'https://agente.artsignsoluciones.com/informefotos/'+props.item.artsign_id" target="_blank" v-if="props.item.type=='AUTORIZACIÓN DE ANUNCIO' && props.item.artsign_id"  >
                <v-btn flat icon color="info">
                  <v-icon>camera</v-icon>
                </v-btn>
              </a> </td>
            <td>{{ props.item.request | formatDate }}</td>
            <td>{{ props.item.request_exp }}</td>
            <td>
              <a :href="props.item.attachment" target="_blank" v-if="props.item.attachment">
                <v-btn flat icon color="info">
                  <v-icon>camera</v-icon>
                </v-btn>
              </a>
            </td>
            <td>

              <v-chip 
                :disabled="loader.saveBtn"
                :color="getColorP(props.item.status)"
                dark
                @click="dialog= true; getData(props.item);"
              >{{ props.item.status }}</v-chip>
                
              
            </td>
            <td>{{ props.item.observations }}</td>
            <td style="max-width: 225px; min-width: 225px">
              <v-tooltip bottom color="info">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="info"
                    v-on="on"
                    @click="edit( props.item.id )"
                    :disabled="loader.saveBtn"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom color="warning">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="warning"
                    v-on="on"
                    @click="viewDetail1( props.item.id )"
                    :disabled="loader.saveBtn"
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalle</span>
              </v-tooltip>
              <v-tooltip bottom color="error">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="error"
                    v-on="on"
                    @click="remove1( props.item.id )"
                    :disabled="loader.saveBtn"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
            </tr>
          </template>
            <template v-slot:expand="props">
        <v-card flat>
          <v-card-text>
            <p><strong>Dirección: </strong>{{ props.item.agents.direction }}</p>
            <p><strong>Distrito: </strong>{{ props.item.agents.district }}</p>
            <p><strong>Provincia: </strong>{{ props.item.agents.province }}</p>
            <p><strong>Departamento: </strong>{{ props.item.agents.department }}</p>
          </v-card-text>
        </v-card>
      </template>
        </v-data-table>
        <!--
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-pagination
            circle
            v-model="pagination1.page"
            :length="pagination1.page_count"
            @input="changePage1"
            @next="changePage1"
            @previous="changePage1"
          ></v-pagination>
          <v-spacer></v-spacer>
        </v-card-actions>-->
      </v-card>

      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Cambiar Estado</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <h2>Información</h2>
                  <p>
                    <strong>Nombre de Comercio:</strong>
                    {{ form.agents.name }}
                  </p>
                  <p>
                    <strong>Dirección:</strong>
                    {{ form.agents.direction }}
                  </p>
                  <p>
                    <strong>Distrito:</strong>
                    {{ form.agents.district }}
                  </p>
                  <p>
                    <strong>Solicitud:</strong>
                    {{ form.type }}
                  </p>
                  <p>
                    <strong>Fecha de Solicitud:</strong>
                    {{ form.request }}
                  </p>
                  <p>
                    <strong>Fecha de Entrega:</strong>
                    {{ form.request_exp }}
                  </p>
                  <p>
                    <strong>Estado:</strong>
                    {{ form.status }}
                  </p>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="!form.attachment">
                  <vue-dropzone
                    id="drop1"
                    ref="dropzone"
                    v-on:vdropzone-success="logoUploaded"
                    :options="dropOptions"
                    class="mb-3"
                  ></vue-dropzone>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-else>
                  <v-flex md6 sm6>
                    <v-btn
                      color="info"
                      @click="getAttachament(form.attachment)"
                    >Ver documento adjunto</v-btn>
                  </v-flex>
                  <v-flex md2 sm2>
                    <v-btn color="error" @click="removePicture()">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <!-- Fecha de solicitud -->
                  <v-menu
                    v-model="pickers.date"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formatDate"
                        label="Fecha de Emisión"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker locale="es-es" v-model="form.date" @input="pickers.date = false"></v-date-picker>
                  </v-menu>
                  <!-- Fecha de expedición -->
                  <v-menu
                    v-model="pickers.exp_date"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formatExpDate"
                        label="Fecha de vencimiento"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="es-es"
                      v-model="form.exp_date"
                      @input="pickers.exp_date = false"
                    ></v-date-picker>
                  </v-menu>

                  <v-flex md6 sm12 class="pr-2">
                    <v-text-field
                      label="Tipo de letrero"
                      hint="Solo si es un letrero"
                      persistent-hint
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 sm12 class="pr-2">
                    <v-text-field label="Número del Autorización" v-model="form.num"></v-text-field>
                  </v-flex>

                  <v-flex md6 sm12 class="pr-2">
                    <v-text-field label="Número de Serie" v-model="form.serie"></v-text-field>
                  </v-flex>
                  <v-flex md8 sm12>
                    <v-text-field label="Observaciones" v-model="form.observations"></v-text-field>
                  </v-flex>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="form.status"
                      label="Estado actual"
                      :items="status"
                      item-text="text"
                      item-value="value"
                    ></v-select>
                  </v-col>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="dialog = false" :disabled="loader.saveBtn">Cerrar</v-btn>
            <v-btn text @click="save(); dialog = false" :disabled="loader.saveBtn">Guardar Cambios</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" bottom right :timeout="2000">
        <v-icon>{{ snackbar.icon }}</v-icon>
        &nbsp;
        {{ snackbar.text }}
        <v-btn flat @click="snackbar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "@/api/axios/config";
import moment from "moment";
import JsonExcel from "vue-json-excel";
import base_url from "@/api/axios/base_url";
import vueDropzone from "vue2-dropzone";
Vue.component("downloadExcel", JsonExcel);
export default {
  components: {
    vueDropzone
  },
  data: () => ({
    dialog: false,
    role: null,
    search1: "",
    search2: "",
    listLoading1: false,
    listLoading2: false,
    bloques: [],
    visibleAgent: false,
    bloque: "",
    type: "",
    agents: "",
    statusForm: "",
    statusfilterSelect: "",
    loader: {
      saveBtn: false,
      disableInput: false
    },
    pagination1: {
      page_count: null,
      page: 1,
      act_page: 0
    },
    snackbar: {
      icon: "",
      text: "",
      color: "",
      show: false
    },
    numRows1: null,
    perPage1: null,
    json_fields: {
      Bloque: "bloque",
      Agente: "agent_id",
      Nombre: "agents.name",
      Dirección: "agents.direction",
      Distrito: "agents.district",
      Provincia: "agents.province",
      Departamento: "agents.department",
      "Tipo de gestión": "type",
      "Exp. N°": "num",
      "N° Serie": "serie",
      "Tipo de Letrero": "sign_type",
      "Fecha de Solicitud": "request",
      "Fecha de Entrega": "request_exp",
      "Fecha de Emisión": "date",
      "Fecha de vencimiento": "exp_date",
      Estado: "status",
      Observaciones: "observations"
    },
    json_data: [],
    data_pendings: {
      headers: [
        {
          text: "Bloque",
          value: "bloque"
        },
        {
          text: "Agente",
          value: "agent_id"
        },
        {
          text: "Nombre",
          value: ""
        },
        {
          text: "Exp. N°",
          value: "num"
        },
        {
          text: "N° Serie",
          value: "serie"
        },
        {
          text: "Tipo",
          value: "type"
        },
        {
          text: "Fecha de Solicitud",
          value: "request"
        },
        {
          text: "Fecha de Entrega",
          value: "request_exp"
        },
        {
          text: "Documento",
          value: "attachment",
          width: 10
        },
        {
          text: "Estado",
          value: "status"
        },
        {
          text: "Observaciones",
          value: "observations"
        },

        {
          text: "",
          value: "",
          sortable: false
        }
      ],
      items: []
    },
    types: [
      { value: "DECLARACION JURADA", text: "Declaración jurada" },
      { value: "LICENCIA", text: "Licencia" },
      { value: "AUTORIZACIÓN DE ANUNCIO", text: "Autorización de Anuncio" },
      { value: "NORMA LEGAL", text: "Norma Legal" }
    ],
    status: [
      { value: "PENDIENTE", text: "Pendiente" },
      { value: "EN CURSO", text: "En curso" },
      { value: "COMPLETADO", text: "Completado" },
      { value: "RECHAZADO", text: "Rechazado" }
    ],
    statusfilter: [
      { value: "PENDIENTE", text: "Pendiente" },
      { value: "EN CURSO", text: "En curso" },
      { value: "VENCIDAD", text: "Solicitud Vencida" }
    ],
    form: {
      agent_id: "",
      num: "",
      serie: "",
      sign_type: "",
      type: "",
      date: "",
      attachment: "",
      exp_date: "",
      status: "",
      observations: "",
      agents: []
    },
    pickers: {
      date: false,
      exp_date: false
    },
    dropOptions: {
      headers: { Authorization: localStorage.getItem("token") },
      url: base_url.serverURI + "nueva-data/attachment",
      maxFilesize: 2, // MB
      maxFiles: 1, //5,
      thumbnailWidth: null, // px
      thumbnailHeight: 240,
      addRemoveLinks: false
    }
  }),
  mounted() {
      //document.getElementById('wrapper1').addEventListener('scroll', this.handleScroll);
      document.getElementsByClassName('v-table__overflow').addEventListener('scroll', this.handleScroll);
      console.log('scrolling Injected');
  },
  computed: {
    formatDate() {
      return this.form.date ? moment(this.form.date).format("DD/MM/YYYY") : "";
    },
    formatExpDate() {
      return this.form.exp_date
        ? moment(this.form.exp_date).format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    this.setRole();
    this.getList1();
  },
  filters: {
    formatDate: function(date) {
      if (date != null && date != "") {
        return moment(date).format("DD-MM-YYYY");
      }
    },
    truncate: function(text, length, suffix) {
      return text.substring(0, length) + suffix;
    }
  },
  methods: {
    handleScroll () {
    //  var scrollTop = document.getElementById('wrapper1').scrollLeft;
   //   document.getElementsByClassName('.v-table__overflow').scrollLeft= scrollTop
    //  console.log( document.getElementById('TableId').scrollLeft)
     // console.log( scrollTop)
      console.log(document.getElemgetElementsByClassNameentById('.v-table__overflow').scrollLeft)
    },
    setRole() {
      if (window.localStorage.role !== undefined) {
        var role = localStorage.getItem("role");
        role = role.replace(/[ '"]+/g, "");
        this.role = role;
      }
    },
    getList1(page = null) {
      this.listLoading1 = true;
      axios
        .get(
          "nueva-data/pendiente?page=" +
            page +
            "&bloque=" +
            this.bloque +
            "&agents=" +
            this.agents +
            "&type=" +
            this.type +
            "&status=" +
            this.statusfilterSelect
        )
        .then(response => {
          if (response.data.status) {
            this.data_pendings.items = response.data.items;
            this.json_data = response.data.items;
            this.bloques = response.data.bloque;
            console.log(this.types);
            if (response.data.items.length > 0) {
              var pages = 0;
              var numRows1 = response.data.num_rows;
              var perPage1 = response.data.per_page;
              pages = parseInt(numRows1) / parseInt(perPage1);
              this.pagination1.page_count = Math.ceil(pages);
            }
          }
        })
        .catch(error => {
          this.snackbar = {
            icon: "error",
            text: error,
            color: "error",
            show: true
          };
        })
        .finally(() => {
          this.listLoading1 = false;
        });
    },
    changePage1() {
      var page = this.pagination1.page - 1;
      this.pagination1.act_page = page;
      this.getList1(page);
    },
    remove1(id) {
      this.$confirm("¿Realmente quieres eliminar este elemento?").then(res => {
        if (res) {
          this.listLoading = true;
          axios
            .delete("nueva-data/" + id)
            .then(response => {
              if (response.data.status) {
                this.snackbar = {
                  icon: "check_circle",
                  text: "¡Elemento eliminado!",
                  color: "success",
                  show: true
                };
              } else {
                this.snackbar = {
                  icon: "error",
                  text: "Ocurrió un error en el servidor...",
                  color: "error",
                  show: true
                };
              }
            })
            .catch(error => {
              this.snackbar = {
                icon: "error",
                text: error,
                color: "error",
                show: true
              };
            })
            .finally(() => {
              this.listLoading = false;
              this.getList(this.pagination.act_page);
            });
        }
      });
    },
    viewDetail1(id) {
      this.$router.push("/data/ver-detalle/" + id);
    },
    edit(id) {
      this.$router.push("/data/editar/" + id);
    },
    getColorP(status) {
      if (status == "PENDIENTE") return "orange";
      else if (status == "APROBADO") return "info";
      else if (status == "COMPLETADO") return "success";
      else if (status == "RECHAZADO") return "danger";
      else return "info";
    },
    getData(item) {
      this.form = item;
      console.log(this.form);
    },
    save() {
      this.loader.saveBtn = true;
      let data = {
        status: this.statusForm,
        num: this.form.num,
        serie: this.form.serie,
        date: this.form.date,
        attachment: this.form.attachment,
        exp_date: this.form.exp_date,
        observations: this.form.observations
      };
      axios
        .put("nueva-data/update/" + this.form.id, data)
        .then(response => {
          if (response.status) {
            this.snackbar = {
              icon: "check_circle",
              text: "¡Cambios guardados con éxito!",
              color: "success",
              show: true
            };
            this.getList1();
          } else {
            this.snackbar = {
              icon: "error",
              text: "Ocurrió un error en el servidor",
              color: "success",
              show: true
            };
          }
        })
        .catch(err => {
          this.snackbar = {
            icon: "error",
            text: err,
            color: "success",
            show: true
          };
        })
        .finally(() => {
          this.loader.saveBtn = false;
        });
    },
    removePicture() {
      this.$confirm("¿Realmente quieres eliminar este elemento?").then(res => {
        if (res) {
          this.form.attachment = "";
        }
      });
    },
    logoUploaded(file, response) {
      if (response.status) {
        this.form.attachment = response.path;
        this.snackbar = {
          icon: "check_circle",
          text: "¡Archivo cargado con éxito!",
          color: "success",
          show: true
        };
      } else {
        this.snackbar = {
          icon: "error",
          text: response.error,
          color: "error",
          show: true
        };
      }
    },
    getAttachament(url) {
      window.open(url, "_blank");
    }
  }
};
</script>
<style lang="css">
.application a {
    cursor: pointer;
    text-decoration: none;
}
.hidden {
  display: none;
}
.dragzone {
  border: dashed 2px #bbb;
  border-radius: 10px;
}
.locate-middle {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  color: #bbb;
}
#drop1 {
  cursor: pointer;
  height: auto;
  padding: 40px;
  border: dashed 2px #bbb;
  color: #bbb;
  font-size: 17px;
  background: transparent;
  border-radius: 10px;
}
#drop1 .dz-preview {
  width: 40%;
}

.dz-image,
.dz-details {
  border-radius: 5px !important;
}
.v-table          { overflow-y: auto; height: 100px; }
.v-table thead th { position: sticky; top: 0; }
</style>

